'use client'

import React, { useState } from 'react'

import { useModalInquiryContext } from '@/context/ModalInquiryContext'
import ContactForm from "@/components/InquryForm/ContactForm";
import { CloseCircleOutlined } from "@ant-design/icons";

const ModalInquiry = ({locale}:{locale:string}) => {
	const { isModalOpen, closeModalInquiry } = useModalInquiryContext();

	return (
		<section className="">
			<div className={`modal-wishlist-block !flex !justify-center items-center `} onClick={closeModalInquiry}>
				<div
					className={`modal-wishlist-main !static !w-fit   max-md:mt-10   ${isModalOpen ? 'open' : ''}`}
					onClick={(e) => {
						e.stopPropagation()
					}}>

					<div className="relative max-h-[90vh] !overflow-y-auto"  >
						<ContactForm locale={locale} className="!py-0"></ContactForm>
						<div className="absolute right-5 top-5 " onClick={closeModalInquiry}>
							<CloseCircleOutlined className="text-xl text-main hover:text-main" />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default ModalInquiry
